import React, { memo } from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import '../../Static/Master/firmtable.css';

const TableBottom4 = ({
    totstkqty,
    totsaleqty,
    totbalqty,
    totprate,
    totsrate
}) => {


    return (
        <>
            <TableRow tabIndex={-1} role="checkbox" className='tbl-row'>



                <TableCell sx={{ p: 1, border: '1px solid #000', fontWeight: 'bold', fontSize: '1rem' }} align='center'>

                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', fontWeight: 'bold', fontSize: '1rem' }} align='center'>

                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', fontWeight: 'bold', fontSize: '1rem' }} align='center'>
                    Total
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', fontWeight: 'bold', fontSize: '1rem' }} align='center'>
                    {totstkqty}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', fontWeight: 'bold', fontSize: '1rem' }} align='center'>
                    {totsaleqty}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', fontWeight: 'bold', fontSize: '1rem' }} align='center'>
                    {totbalqty}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', fontWeight: 'bold', fontSize: '1rem' }} align='center'>
                    {totprate}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', fontWeight: 'bold', fontSize: '1rem' }} align='center'>
                    {totsrate}
                </TableCell>




            </TableRow>
        </>
    );
};

export default TableBottom4;
